import { useEffect, useMemo, useState } from 'react';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { East, West } from '@mui/icons-material';
import { Skeleton, Typography, Box } from "@mui/material";
import NotFound from "../../../components/notfound/NotFound";
import {useStrategiesContext} from "../../../context/derivatives/strategies/DerivativesStrategiesContext";
import useResponsive from "../../../components/hooks/useResponsive";
import {COLORS} from "../../../ui/Theme";
import DerivativesStrategiesSymbol from "./DerivativesStrategiesSymbol";

const DerivativesStrategiesSymbols = () => {
    const {
        selectedSymbol,
        setSelectedSymbol,
        strategyTableData,
        filteredTableData,
    } = useStrategiesContext();

    const [showAll, setShowAll] = useState(false);
    const { isXs, isSm, isMd, isLg, isXl } = useResponsive();

    const visibleCount = isXl ? 10
        : isLg ? 6
            : isMd ? 3
                : isSm ? 3
                    : isXs ? 1
                        : 2;

    // make symbols unique
    const uniqueSymbols = useMemo(() => {
        if (!strategyTableData?.data) return [];
        const seen = new Set();
        return strategyTableData.data.filter(item => {
            if (seen.has(item.base_equity_symbol)) {
                return false;
            }
            seen.add(item.base_equity_symbol);
            return true;
        });
    }, [strategyTableData?.data]);

    useEffect(() => {
        if (
            selectedSymbol !== 'همه' &&
            !uniqueSymbols.some((symbol) => symbol.base_equity_symbol === selectedSymbol)
        ) {
            setSelectedSymbol('همه');
        }
    }, [selectedSymbol, uniqueSymbols]);

    const visibleSymbols = useMemo(() => {
        return showAll ? uniqueSymbols : uniqueSymbols.slice(0, visibleCount);
    }, [uniqueSymbols, showAll, visibleCount]);

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: showAll ? "flex-start" : "center",
                gap: "20px",
            }}
        >
            <Typography
                sx={{
                    color: COLORS.BLACK,
                    fontSize: "16px",
                    fontWeight: 700,
                    marginTop: showAll && "8px",
                }}
            >
                نمادها
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "12px",
                }}
            >
                {(filteredTableData.isValidating || filteredTableData.isLoading) ? (
                    Array.from({ length: visibleCount }).map((_, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                gap: "12px",
                            }}
                        >
                            <Skeleton
                                variant="rounded"
                                width="100px"
                                height="40px"
                                sx={{
                                    borderRadius: "18px",
                                }}
                            />
                        </Box>
                    ))
                ) : (
                    <>
                        <DerivativesStrategiesSymbol
                            title="همه"
                            avatar={
                                <ViewModuleIcon
                                    sx={{
                                        fontSize: "12px",
                                    }}
                                />
                            }
                            selected={selectedSymbol === "همه"}
                            onClick={() => setSelectedSymbol("همه")}
                        />
                        {filteredTableData.data.length > 0 ? (
                            <>
                                {visibleSymbols.map((symbol) => (
                                    <DerivativesStrategiesSymbol
                                        key={symbol.base_equity_symbol}
                                        title={symbol.base_equity_symbol}
                                        avatar={symbol.base_equity_symbol.split(" ")[0][0]}
                                        selected={selectedSymbol === symbol.base_equity_symbol}
                                        onClick={() => setSelectedSymbol(symbol.base_equity_symbol)}
                                    />
                                ))}
                                {uniqueSymbols.length > visibleCount && (
                                    <Box
                                        onClick={() => setShowAll(!showAll)}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: COLORS.SOFTBLUE,
                                            width: "40px",
                                            height: "40px",
                                            cursor: "pointer",
                                            border: "1px solid #BBDEFB",
                                            borderRadius: "18px",
                                        }}
                                    >
                                        {showAll ? (
                                            <East sx={{ fontSize: "16px" }} />
                                        ) : (
                                            <West sx={{ fontSize: "16px" }} />
                                        )}
                                    </Box>
                                )}
                            </>
                        ) : (
                            <Box>
                                <NotFound />
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </Box>
    );
};

export default DerivativesStrategiesSymbols;
